import { useEffect } from "react";
import jwtDecode from "jwt-decode";
import { refreshTokenFetch } from "../services/RefreshToken";

const useTokenExpiry = () => {
  // Function to refresh token
  const refreshToken = async () => {
    const { status, message } = await refreshTokenFetch();
  };
  // Function to check if token is about to expire
  const checkTokenExpiry = () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decodedToken.exp - currentTime <= 300) {
      refreshToken();
    }
  };
  // Use effect to check for token expiry at regular intervals
  useEffect(() => {
    const interval = setInterval(() => {
      checkTokenExpiry();
    }, 60000);
    checkTokenExpiry();
    return () => clearInterval(interval);
  }, []);

  return null;
};

export default useTokenExpiry;
